module.exports = __webpack_public_path__ + "assets/add9c12a925995aba75cb1837dfd97ba.jpg";